// extracted by mini-css-extract-plugin
export default {"status-indicator":"status-indicator_status-indicator__ZRDo-"};